/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import toast, { Toaster } from 'react-hot-toast'
import api from '../../../config/AxiosInstance'
import Loading from '../../../components/atoms/Loading'
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
  Table
} from 'react-bootstrap'
import Breadcrumb from '../../../components/Label/Breadcrumb'
import {
  convertDateWithoutTime,
  convertDateWithTime,
  transformKey
} from '../../../helpers/constants'
import { ChevronDown, ChevronUp, Edit, Trash2 } from 'lucide-react'
import Swal from 'sweetalert2'

const cardStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelDetailStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#999',
  textTransform: 'uppercase',
  marginBottom: '0.25rem',
  letterSpacing: '0.5px'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const StyledDetailField = ({ label, value, col = 12, address = null }) => {
  return (
    <Form.Group className={`mb-3 col-12 col-md-${col}`}>
      <Form.Label style={labelDetailStyle}>{label}</Form.Label>
      {address ? (
        <div
          dangerouslySetInnerHTML={{
            __html: value
          }}
          className="px-3 py-2 bg-white rounded border"
          style={{
            fontSize: '0.9rem',
            minHeight: '40px',
            borderColor: '#ced4da'
          }}
        />
      ) : (
        <Form.Control
          type="text"
          value={value || '-'}
          readOnly
          className="px-3 bg-light"
          style={{
            fontSize: '0.9rem',
            height: '40px',
            borderRadius: '8px',
            border: '1px solid #ced4da',
            cursor: 'not-allowed'
          }}
        />
      )}
    </Form.Group>
  )
}

function DetailPurchaseOrderPacking() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState({
    page: false,
    submit: false
  })
  const [collapsible, setCollapsible] = useState([
    {
      label: 'po_info',
      open: true
    },
    {
      label: 'arrival_info',
      open: true
    },
    {
      label: 'vehicle',
      open: true
    },
    {
      label: 'packing',
      open: true
    }
  ])
  const renderDocumentVehicle = (valueVehicle, target) => {
    if (![null, undefined, ''].includes(valueVehicle[target])) {
      if (valueVehicle[target] instanceof File) {
        return <span className="text-primary">{valueVehicle[target].name}</span>
      }
      if (
        typeof valueVehicle[target] === 'boolean' &&
        ['sim_validity', 'stnk_validity'].includes(target)
      ) {
        return valueVehicle[target] === true ? 'VALID' : 'INVALID'
      }
      if (
        typeof valueVehicle[target] === 'string' &&
        /^https?:\/\//.test(valueVehicle[target])
      ) {
        return (
          <a
            href={valueVehicle[target]}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary text-decoration-none"
          >
            {valueVehicle[target]?.split('/').pop()}
          </a>
        )
      }
      return valueVehicle[target]
    }
    return '-'
  }
  const columnVehicle = [
    { key: 'sequence', label: 'No' },
    { key: 'plate_no', label: 'Plate No' },
    {
      key: 'sim_doc',
      label: 'SIM',
      component: (data) => renderDocumentVehicle(data, 'sim_doc'),
      className: 'text-end'
    },
    {
      key: 'sim_validity',
      label: 'Validity',
      component: (data) => renderDocumentVehicle(data, 'sim_validity'),
      className: 'text-end'
    },
    {
      key: 'sim_notes',
      label: 'NOTES',
      component: (data) => renderDocumentVehicle(data, 'sim_notes'),
      className: 'text-end'
    },
    {
      key: 'stnk_doc',
      label: 'STNK',
      component: (data) => renderDocumentVehicle(data, 'stnk_doc'),
      className: 'text-end'
    },
    {
      key: 'stnk_validity',
      label: 'Validity',
      component: (data) => renderDocumentVehicle(data, 'stnk_validity'),
      className: 'text-end'
    },
    {
      key: 'stnk_notes',
      label: 'NOTES',
      component: (data) => renderDocumentVehicle(data, 'stnk_notes'),
      className: 'text-end'
    },
    {
      key: 'action',
      label: 'Action',
      component: (data) => (
        <div key={data.id} className="d-flex gap-2 justify-content-end">
          <Button
            variant="transparent"
            className="btn-secondary opacity-25"
            disabled
          >
            <Edit size={14} />
          </Button>
        </div>
      )
    }
  ]
  const columnPacking = [
    { key: 'sequence', label: 'No' },
    {
      key: 'item',
      label: 'Item',
      component: (data) => data?.item?.item_name || ''
    },
    {
      key: 'total_pack',
      label: 'Total Pack',
      className: 'text-end'
    },
    {
      key: 'action',
      label: 'Action',
      component: (data) => (
        <div key={data.id} className="d-flex gap-2 justify-content-end">
          <Button
            variant="transparent"
            className="btn-secondary opacity-25"
            disabled
          >
            <Edit size={14} />
          </Button>
          <Button
            variant="transparent"
            className="btn-secondary opacity-25"
            disabled
          >
            <Trash2 size={14} />
          </Button>
        </div>
      ),
      className: 'text-end'
    }
  ]
  const columnReceipt = [
    { key: 'item', label: 'Item' },
    {
      key: 'do_pack',
      label: 'DO Pack',
      component: (data) => data?.do_pack?.split(' ')[0] || '',
      className: 'text-end'
    },
    {
      key: 'acc_pack',
      label: 'ACC Pack',
      component: (data) => data?.acc_pack?.split(' ')[0] || '',
      className: 'text-end'
    }
  ]
  const fetchData = async () => {
    try {
      setLoading((prevLoading) => ({ ...prevLoading, page: true }))
      const res = await api.get(`inbound/pr-draft/${id}`)
      const { data } = res
      if (data.success) {
        setData(data.data)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setLoading((prevLoading) => ({ ...prevLoading, page: false }))
    }
  }
  const handleCollapse = (value) => {
    setCollapsible((prevState) =>
      prevState.map((item) => {
        if (item.label === value) {
          const open = !item.open
          return {
            ...item,
            open,
            icon: open ? <ChevronUp size={16} /> : <ChevronDown size={16} />
          }
        }
        return item
      })
    )
  }
  const handleSendToErp = async (values) => {
    const showSendToErpAlert = (error = null) => {
      if (!error) {
        Swal.fire({
          title: 'Send to ERP?',
          text: "This action can't be repeated!",
          icon: 'warning',
          iconColor: '#828282',
          showCancelButton: true,
          confirmButtonColor: '#f89d1d',
          confirmButtonText: 'Send',
          customClass: {
            title: 'swal-title-outbound',
            popup: 'swal-popup-outbound',
            actions: 'swal-cancel-pr'
          }
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              setLoading((prevLoading) => ({ ...prevLoading, submit: true }))
              const res = await api.post(
                `/inbound/pr-draft/${data.po_info.id}/retry-send`
              )
              const { data: dataResErp } = res
              if (dataResErp.success) {
                toast.success('Successfully send to ERP!', {
                  position: 'top-right',
                  style: {
                    fontSize: '14px',
                    fontWeight: '600'
                  }
                })
                fetchData()
              }
            } catch (error) {
              const errMsg =
                error?.response?.data?.errors?.message ||
                error?.message ||
                'An error occurred'
              toast.error(errMsg, {
                position: 'top-right',
                style: {
                  fontSize: '14px',
                  fontWeight: '600'
                }
              })
              // Show the SweetAlert again after error
              showSendToErpAlert(errMsg)
            } finally {
              setLoading((prevLoading) => ({ ...prevLoading, submit: false }))
            }
          }
        })
      } else {
        Swal.fire({
          html: `<p>Send To ERP <b>FAILED</b></p><br><p>Reason:${error}</p>`,
          icon: 'error',
          iconColor: '#c12727',
          showCancelButton: false,
          confirmButtonColor: '#f89d1d',
          confirmButtonText: 'Resend',
          customClass: {
            title: 'swal-title-outbound',
            popup: 'swal-popup-outbound',
            actions: 'swal-cancel-pr'
          }
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              setLoading((prevLoading) => ({ ...prevLoading, submit: true }))
              const res = await api.post(
                `/inbound/pr-draft/${data.po_info.id}/retry-send`
              )
              const { data: dataResErp } = res
              if (dataResErp.success) {
                toast.success('Successfully send to ERP!', {
                  position: 'top-right',
                  style: {
                    fontSize: '14px',
                    fontWeight: '600'
                  }
                })
                fetchData()
              }
            } catch (error) {
              const errMsg =
                error?.response?.data?.errors?.message ||
                error?.message ||
                'An error occurred'
              toast.error(errMsg, {
                position: 'top-right',
                style: {
                  fontSize: '14px',
                  fontWeight: '600'
                }
              })
              // Show the SweetAlert again after error
              showSendToErpAlert(errMsg)
            } finally {
              setLoading((prevLoading) => ({ ...prevLoading, submit: false }))
            }
          }
        })
      }
    }
    showSendToErpAlert()
  }
  useEffect(() => {
    if (!id) {
      toast.error('Purchase Order not found!', {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
      return navigate('/inbound/purchase-receipt')
    }
    fetchData()
  }, [id])

  if (loading.page) {
    return <Loading />
  }
  return (
    <>
      <Toaster />
      <Container className="mb-5">
        <Row>
          <Col md={12} className="mt-3">
            <Breadcrumb
              label={data?.po_info?.po_code || ''}
              link="/inbound/purchase-receipt"
              back="PURCHASE RECEIPT"
              type="BadgeStatusPrList"
              status={data?.po_info?.draft_status || 'done'}
            />
          </Col>
        </Row>
        <Row className="my-3">
          <Col md={12} className="mb-2">
            <Card style={cardStyle}>
              <Row className="mb-3">
                <Col
                  md={12}
                  className="d-flex justify-content-between align-items-center"
                >
                  <h5
                    className="text-secondary mb-0"
                    style={{ fontSize: '1rem', fontWeight: 'bold' }}
                  >
                    PO INFO
                  </h5>
                  {collapsible[0].open ? (
                    <ChevronUp
                      size={16}
                      onClick={() => handleCollapse('po_info')}
                      style={{ cursor: 'pointer' }}
                    />
                  ) : (
                    <ChevronDown
                      size={16}
                      onClick={() => handleCollapse('po_info')}
                      style={{ cursor: 'pointer' }}
                    />
                  )}
                </Col>
              </Row>
              <Collapse in={collapsible[0].open}>
                <div id="collapse-po" className="row">
                  <StyledDetailField
                    label="#po"
                    value={data?.po_info?.po_code}
                    col={3}
                  />
                  <StyledDetailField
                    label="po type"
                    value={data?.po_info?.pr_type}
                    col={3}
                  />
                  <StyledDetailField
                    label="branch"
                    value={data?.po_info?.branch}
                    col={3}
                  />
                  <StyledDetailField
                    label="supplier"
                    value={data?.po_info?.supplier}
                    col={3}
                  />
                  <StyledDetailField
                    label="SERIES"
                    value={data?.po_info?.series_number}
                    col={3}
                  />
                  <StyledDetailField
                    label="accepted warehouse"
                    value={data?.po_info?.acc_warehouse_id}
                    col={3}
                  />
                  <StyledDetailField
                    label="method"
                    value={transformKey(data?.po_info?.pr_method || '')}
                    col={3}
                  />
                  <StyledDetailField
                    label="#ERP DOC. NO"
                    value={data?.po_info?.pr_code_erp || ''}
                    col={3}
                  />
                </div>
              </Collapse>
            </Card>
          </Col>
        </Row>
        {/* ARRIVAL */}
        <Row className="my-3">
          <Col md={12} className="mb-2">
            <Card style={cardStyle}>
              <Row className="mb-3">
                <Col
                  md={12}
                  className="d-flex justify-content-between align-items-center"
                >
                  <h5
                    className="text-secondary mb-0"
                    style={{ fontSize: '1rem', fontWeight: 'bold' }}
                  >
                    ARRIVAL INFO
                  </h5>
                  {collapsible[1].open ? (
                    <ChevronUp
                      size={16}
                      onClick={() => handleCollapse('arrival_info')}
                      style={{ cursor: 'pointer' }}
                    />
                  ) : (
                    <ChevronDown
                      size={16}
                      onClick={() => handleCollapse('arrival_info')}
                      style={{ cursor: 'pointer' }}
                    />
                  )}
                </Col>
              </Row>
              <Collapse in={collapsible[1].open}>
                <div id="collapse-arrival" className="row">
                  <StyledDetailField
                    label="#do"
                    value={data?.arrival_info?.do}
                    col={3}
                  />
                  <StyledDetailField
                    label="expedition"
                    value={data?.arrival_info?.expedition}
                    col={3}
                  />
                  {data?.po_info?.pr_type === 'import' && (
                    <>
                      <StyledDetailField
                        label="pib date"
                        value={
                          data?.arrival_info?.pib_date
                            ? convertDateWithoutTime(
                                data?.arrival_info?.pib_date
                              )
                            : '-'
                        }
                        col={3}
                      />
                      <StyledDetailField
                        label="#aju"
                        value={data?.arrival_info?.aju}
                        col={3}
                      />
                    </>
                  )}
                  <StyledDetailField
                    label="pic name"
                    value={data?.arrival_info?.pic_name}
                    col={3}
                  />
                  <StyledDetailField
                    label="pic number"
                    value={data?.arrival_info?.pic_number}
                    col={3}
                  />
                </div>
              </Collapse>
            </Card>
          </Col>
        </Row>
        {/* VEHICLES*/}
        <Row className="my-3">
          <Col md={12} className="mb-2">
            <Card style={cardStyle}>
              <Row className="mb-3">
                <Col
                  md={12}
                  className="d-flex justify-content-between align-items-center"
                >
                  <h5
                    className="text-secondary mb-0"
                    style={{ fontSize: '1rem', fontWeight: 'bold' }}
                  >
                    VEHICLES
                  </h5>
                  {collapsible[2].open ? (
                    <ChevronUp
                      size={16}
                      onClick={() => handleCollapse('vehicle')}
                      style={{ cursor: 'pointer' }}
                    />
                  ) : (
                    <ChevronDown
                      size={16}
                      onClick={() => handleCollapse('vehicle')}
                      style={{ cursor: 'pointer' }}
                    />
                  )}
                </Col>
              </Row>
              <Collapse in={collapsible[2].open}>
                <div id="collapse-vehicle">
                  <Row className="p-2 me-2 mb-3">
                    <Table>
                      <thead>
                        <tr>
                          {columnVehicle.map((column) => (
                            <th
                              style={tableHeaderStyle}
                              className={`align-middle p-2 ${column.className}`}
                              key={column.key}
                            >
                              <span>{column.label}</span>
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {data?.vehicles?.length === 0 && (
                          <tr>
                            <td
                              colSpan={columnVehicle.length}
                              className="p-2 text-center"
                            >
                              No data
                            </td>
                          </tr>
                        )}
                        {data?.vehicles?.map((vehicle, indexVehicle) => (
                          <tr key={indexVehicle}>
                            {columnVehicle.map((column) => (
                              <td
                                key={column.key}
                                className={`align-middle p-2 ${column.className}`}
                              >
                                {column.key === 'sequence' && indexVehicle + 1}
                                {column.component && column.component(vehicle)}
                                {!column.component && vehicle[column.key]}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Row>
                </div>
              </Collapse>
            </Card>
          </Col>
        </Row>
        {/* PACKING*/}
        <Row className="my-3">
          <Col md={12} className="mb-2">
            <Card style={cardStyle}>
              <Row className="mb-3">
                <Col
                  md={12}
                  className="d-flex justify-content-between align-items-center"
                >
                  <h5
                    className="text-secondary mb-0"
                    style={{ fontSize: '1rem', fontWeight: 'bold' }}
                  >
                    PACKING
                  </h5>
                  {collapsible[3].open ? (
                    <ChevronUp
                      size={16}
                      onClick={() => handleCollapse('packing')}
                      style={{ cursor: 'pointer' }}
                    />
                  ) : (
                    <ChevronDown
                      size={16}
                      onClick={() => handleCollapse('packing')}
                      style={{ cursor: 'pointer' }}
                    />
                  )}
                </Col>
              </Row>
              <Collapse in={collapsible[3].open}>
                <div id="collapse-packing">
                  <Row className="p-2 me-2 mb-3">
                    <Table>
                      <thead>
                        <tr>
                          {columnPacking.map((column) => (
                            <th
                              style={tableHeaderStyle}
                              className={`align-middle p-2 ${column.className}`}
                              key={column.key}
                            >
                              <span>{column.label}</span>
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {data?.items_coa?.length === 0 && (
                          <tr>
                            <td
                              colSpan={columnPacking.length}
                              className="p-2 text-center"
                            >
                              No data
                            </td>
                          </tr>
                        )}
                        {data?.items_coa?.map((packing, indexPacking) => (
                          <tr key={indexPacking}>
                            {columnPacking.map((column) => (
                              <td
                                key={column.key}
                                className={`align-middle p-2 ${column.className}`}
                              >
                                {column.key === 'sequence' && indexPacking + 1}
                                {column.component && column.component(packing)}
                                {!column.component && packing[column.key]}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Row>
                </div>
              </Collapse>
            </Card>
          </Col>
        </Row>
        {/* ITEM RECEIPT DETAILS*/}
        <Row className="mb-1">
          <Col md={12} className="mb-2">
            <Card style={cardStyle}>
              <Row className="mb-3">
                <Col md={12}>
                  <h5
                    className="text-secondary"
                    style={{ fontSize: '1rem', fontWeight: 'bold' }}
                  >
                    ITEM RECEIPT DETAILS
                  </h5>
                </Col>
              </Row>
              <Col md={12} className="mb-2">
                <Table>
                  <thead>
                    <tr>
                      {columnReceipt.map((column) => (
                        <th
                          style={tableHeaderStyle}
                          className={`align-middle p-2 ${column.className}`}
                          key={column.key}
                        >
                          <span>{column.label}</span>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data?.receipt_detail?.length === 0 && (
                      <tr>
                        <td
                          colSpan={columnReceipt.length}
                          className="p-2 text-center"
                        >
                          No data
                        </td>
                      </tr>
                    )}
                    {data?.receipt_detail?.map((packing, indexPacking) => (
                      <tr key={indexPacking}>
                        {columnReceipt.map((column) => (
                          <td
                            key={column.key}
                            className={`align-middle p-2 ${column.className}`}
                          >
                            {column.key === 'sequence' && indexPacking + 1}
                            {column.component && column.component(packing)}
                            {!column.component && packing[column.key]}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Col>
            </Card>
          </Col>
        </Row>
        {data?.err_notes && (
          <Row className="my-4">
            <div className="d-flex justify-content-between w-100">
              <Col md={6}>
                <div className="d-flex align-items-center h-100">
                  <span>Failed Reason: </span>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data?.erp?.err_notes
                    }}
                  ></div>
                </div>
              </Col>
              <Col md={6} className="d-flex justify-content-end">
                <Button
                  variant="transparent"
                  className={`${
                    loading.submit
                      ? 'btn-secondary opacity-25'
                      : 'btn-primary-orange'
                  }`}
                  disabled={loading.submit}
                  onClick={handleSendToErp}
                >
                  {loading.submit ? 'Sending...' : 'Send To ERP'}
                </Button>
              </Col>
            </div>
          </Row>
        )}
        <Row>
          <Col md={12} className="mb-2">
            <Card style={cardStyle}>
              <Row>
                <StyledDetailField
                  label="created by"
                  value={
                    !data?.po_info?.createdBy ? '-' : data?.po_info?.createdBy
                  }
                  col={3}
                />
                <StyledDetailField
                  label="created at"
                  value={
                    !data?.po_info?.createdAt
                      ? '-'
                      : convertDateWithTime(data?.po_info?.createdAt)
                  }
                  col={3}
                />
                <StyledDetailField
                  label="last updated by"
                  value={
                    !data?.po_info?.updatedBy ? '-' : data?.po_info?.updatedBy
                  }
                  col={3}
                />
                <StyledDetailField
                  label="last updated at"
                  value={
                    !data?.po_info?.updatedAt
                      ? '-'
                      : convertDateWithTime(data?.po_info?.updatedAt)
                  }
                  col={3}
                />
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default DetailPurchaseOrderPacking
